import * as z from 'zod/v4';

const EVENT_STATUS_VARIANTS = [
  'Undefined',
  // All Sports
  // The match is scheduled to be played
  'NotStarted',
  // Handball
  // The match is about to start
  'AboutToStart',
  // All sports (Basket, Baseball: started)
  // The match is currently in progress
  'Live',
  // Hockey
  // The match is in the first period
  'FirstPeriod',
  // Hockey
  // The match is in the second period
  'SecondPeriod',
  // Hockey
  // The match is in the third period
  'ThirdPeriod',
  // Football, Handball, Basket, Am. Football
  // The match is in the first half
  'FirstHalf',
  // Football, Handball, Basket, Am. Football
  // The match is in the second half
  'SecondHalf',
  // Basket
  // The match is in the first quarter
  'FirstQuarter',
  // Basket
  // The match is in the second quarter
  'SecondQuarter',
  // Basket
  // The match is in the third quarter
  'ThirdQuarter',
  // Basket
  // The match is in the fourth quarter
  'FourthQuarter',
  // Baseball
  // The match is in the first inning
  'FirstInning',
  // Baseball
  // The match is in the second inning
  'SecondInning',
  // Baseball
  // The match is in the third inning
  'ThirdInning',
  // Baseball
  // The match is in the fourth inning
  'FourthInning',
  // Baseball
  // The match is in the fifth inning
  'FifthInning',
  // Baseball
  // The match is in the sixth inning
  'SixthInning',
  // Baseball
  // The match is in the seventh inning
  'SeventhInning',
  // Baseball
  // The match is in the eighth inning
  'EighthInning',
  // Baseball
  // The match is in the ninth inning
  'NinthInning',
  // Football, Handball, Basket, Am. Football, Baseball
  // The match is in overtime
  'Overtime',
  // Football, Hockey, Handball
  // The match is in the first extra period
  'FirstExtraPeriod',
  // Football, Hockey, Handball
  // The match is in the second extra period
  'SecondExtraPeriod',
  // Hockey
  // The match is in the third extra period
  'ThirdExtraPeriod',
  // Football, Hockey, Handball, Basket
  // Waiting for announcement of penalties
  'AwaitingPenalties',
  // Football, Hockey, Handball, Basket
  // Penalties are ongoing
  'Penalties',
  // Football, Hockey, Handball, Basket, Am. Football, Baseball
  // The match is paused
  'Pause',
  // Football, Hockey, Handball, Basket
  // Waiting on referee to announce extra time
  'AwaitingExtratime',
  // Football, Hockey, Handball, Basket, Am. Football, Baseball
  // The match has been interrupted
  'Interrupted',
  // Football, Hockey, Handball, Basket, Am. Football, Baseball
  // The match has been abandoned
  'Abandoned',
  // Football, Hockey, Bandy, Floorball, Basket, Speedway, Am. Football, Baseball
  // The match has been postponed to a future date
  'Postponed',
  // Football, Hockey, Bandy, Floorball, Handball, Basket, Speedway, Am. Football, Baseball
  // The match has been temporarily delayed and will be continued
  'Delayed',
  // Football, Hockey, Bandy, Floorball, Handball, Basket, Speedway, Am. Football, Baseball
  // The match has been cancelled and will not be played
  'Cancelled',
  // Football, Hockey, Bandy, Floorball, Handball, Basket, Speedway, Am. Football, Baseball
  // The match has ended
  'Ended',
  // Football, Bandy, Floorball, Handball, Speedway, Am. Football
  // The match results have been confirmed
  'Closed',
  // Football, Handball, Am. Football
  // The match is in halftime
  'Halftime',
  // Football, Handball, Am. Football
  // The match has ended
  'Fulltime',
  // Football, Handball, Am. Football
  // Extra time has been added
  'Extratime',
  // Football, Hockey, Handball, Basket, Am. Football, Baseball (aet)
  // The match has ended after extra time
  'EndedAfterExtratime',
  // Football, Hockey, Handball (ap)
  // The match has ended after penalties
  'EndedAfterPenalties',

  /*
    Legacy statuscodes
  */
  'FallbackFourthPeriod',
  'FallbackFifthPeriod',
  'FallbackFirstSet',
  'FallbackSecondSet',
  'FallbackThirdSet',
  'FallbackFourthSet',
  'FallbackFifthSet',
  'FallbackExtraTimeHalftime',
  'FallbackSuspended',
  'FallbackWalkover',
  'FallbackParticipantRetired',
  'FallbackInFirstBreak',
  'FallbackInSecondBreak',
  'FallbackInThirdBreak',
  'FallbackGoldenSet',
  'FallbackSixthSet',
  'FallbackSeventhSet',
  'FallbackFrame1',
  'FallbackFrame2',
  'FallbackFrame3',
  'FallbackFrame4',
  'FallbackFrame5',
  'FallbackFrame6',
  'FallbackFrame7',
  'FallbackFrame8',
  'FallbackFrame9',
  'FallbackFrame10',
  'FallbackFrame11',
  'FallbackFrame12',
  'FallbackFrame13',
  'FallbackFrame14',
  'FallbackFrame15',
  'FallbackFrame16',
  'FallbackFrame17',
  'FallbackFrame18',
  'FallbackFrame19',
  'FallbackFrame20',
  'FallbackFrame21',
  'FallbackFrame22',
  'FallbackFrame23',
  'FallbackFrame24',
  'FallbackFrame25',
  'FallbackFrame26',
  'FallbackFrame27',
  'FallbackFrame28',
  'FallbackFrame29',
  'FallbackFrame30',
  'FallbackFrame31',
  'FallbackFrame32',
  'FallbackFrame33',
  'FallbackFrame34',
  'FallbackFrame35',
  'FallbackFrame36',
  'FallbackFrame37',
  'FallbackAwaitingSuddenDeath',
  'FallbackInSuddenDeath',
  'FallbackEndedAfterSuddenDeath',
  'FallbackFirstInningsHomeTeam',
  'FallbackFirstInningsAwayTeam',
  'FallbackSecondInningsHomeTeam',
  'FallbackSecondInningsAwayTeam',
  'FallbackAwaitingSuperOver',
  'FallbackInSuperOverHomeTeam',
  'FallbackInSuperOverAwayTeam',
  'FallbackEndedAfterSuperOver',
  'FallbackStumps',
  'FallbackDefaulted',
  'FallbackWalkoverHomeTeamWon',
  'FallbackWalkoverAwayTeamWon',
  'FallbackParticipantRetiredHomeTeamWon',
  'FallbackParticipantRetiredAwayTeamWon',
  'FallbackDefaultedHomeTeamWon',
  'FallbackDefaultedAwayTeamWon',
  'FallbackLunchBreak',
  'FallbackTeaBreak',
] as const;

/**
 * Zod enum - The status of an event
 */
export const eventStatusEnum = z.enum(EVENT_STATUS_VARIANTS);

/**
 * TS event status type
 */
export type EventStatus = z.infer<typeof eventStatusEnum>;
